<template>
  <div class="box-header">
    <slot></slot>
  </div>
</template>

<script lang="tsx" setup name="SmartHedaer"></script>
